import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { AppText, Button, Card } from "./ui";

const INPUT = "w-full min-w-0 min-h-[48px] bg-white rounded-2xl border-2 border-km-border px-4 font-text text-[16px] text-km-ink outline-none focus:border-km-coral";

const Num = ({ label, value, onChange, testId, step = 1 }) => (
  <label className="flex flex-col gap-1 flex-1 min-w-0">
    <AppText variant="label" className="text-km-ink">{label}</AppText>
    <input type="number" inputMode="decimal" min="0" step={step} value={value} onChange={(e) => onChange(e.target.value)} className={INPUT} data-testid={testId} />
  </label>
);

export function ActivityReport({ inactivity, reload }) {
  const [open, setOpen] = useState(!!inactivity);
  const [days, setDays] = useState(inactivity?.days ? String(Math.min(120, inactivity.days)) : "7");
  const [walk, setWalk] = useState("");
  const [run, setRun] = useState("");
  const [core, setCore] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const r = await api.runnerActivity({ days: Number(days) || 7, walk_km: Number(walk) || 0, run_km: Number(run) || 0, core_sessions: Number(core) || 0, note });
      toast.success(r.message, { duration: 9000 });
      setOpen(false); setWalk(""); setRun(""); setCore(""); setNote("");
      reload();
    } catch (e) { toast.error(e.message || "Erreur"); } finally { setBusy(false); }
  };
  return (
    <div className="mt-6" data-testid="activity-card">
      <button type="button" onClick={() => setOpen((v) => !v)} className="w-full text-left flex items-center justify-between gap-3 py-2" data-testid="activity-toggle">
        <div>
          <AppText variant="title">{inactivity ? inactivity.title : "Vacances, rando, autre sport ?"}</AppText>
          <AppText variant="caption" className="text-km-muted">{inactivity ? `${inactivity.days} jours sans séance validée — dis-moi ce que tu as fait, le programme en tient compte au lieu de reculer.` : "Déclare ce que tu as fait hors programme : marche, course, gainage. Ça compte."}</AppText>
        </div>
        <span className="text-km-muted text-xl">{open ? "−" : "+"}</span>
      </button>
      {open ? (
        <Card className="flex flex-col gap-3">
          {inactivity ? <AppText variant="body" className="text-km-ontertiary">{inactivity.advice}</AppText> : null}
          <div className="flex gap-3">
            <Num label="Sur combien de jours ?" value={days} onChange={setDays} testId="activity-days" />
            <Num label="Km de marche" value={walk} onChange={setWalk} testId="activity-walk" step="0.5" />
          </div>
          <div className="flex gap-3">
            <Num label="Km de course" value={run} onChange={setRun} testId="activity-run" step="0.5" />
            <Num label="Séances de gainage" value={core} onChange={setCore} testId="activity-core" />
          </div>
          <input value={note} onChange={(e) => setNote(e.target.value)} maxLength={300} placeholder="Un mot pour Éric (facultatif) : rando en montagne, vélo, piscine…" className={INPUT} data-testid="activity-note" />
          <Button title="C'est noté, adapte mon programme" onClick={submit} loading={busy} size="md" testID="activity-submit" />
        </Card>
      ) : null}
    </div>
  );
}
